// Global Types
import type {
  $Translate,
} from 'common.language';
import type {
  $Model,
  $ModelUpsertParams,
} from 'common.data';

// Global Components
import * as React from 'react';
import {
  Col,
  Row,
} from 'reactstrap';
import {
  AvField,
} from 'availity-reactstrap-validation';
import {
  InputDateTime,
} from '@vroskus/library-components';

// Types
import type {
  $ReducerState,
} from '../../../redux';

export type $OwnProps = $Translate & {
  item: $Model<'RegattaSchedule'> | $ModelUpsertParams<'RegattaSchedule'>;
  range: {
    max?: Date;
    min?: Date;
  };
};

export type $StateProps = {
  main: $ReducerState<'main'>;
};

export type $DispatchProps = Record<string, unknown>;

type $Props = $DispatchProps & $OwnProps & $StateProps;

const RegattaScheduleFieldsView = function ({
  item,
  main,
  range,
  t,
}: $Props) {
  return (
    <>
      <Row>
        <Col sm={6}>
          <InputDateTime
            label={t('Event start date')}
            labelOpenCalendar={t('Open calendar')}
            name={'StartDate'}
            range={range}
            required
            timezone={main.timezone}
            value={item.StartDate}
          />
        </Col>
        <Col sm={6}>
          <InputDateTime
            label={t('Event end date')}
            labelOpenCalendar={t('Open calendar')}
            name={'EndDate'}
            range={range}
            timezone={main.timezone}
            value={item.EndDate}
          />
        </Col>
      </Row>
      <Row>
        <Col>
          <AvField
            label={t('Event title')}
            name={'Name'}
            required
            value={item.Name}
          />
        </Col>
      </Row>
      <Row>
        <Col>
          <AvField
            label={t('Description')}
            maxLength={'255'}
            name={'Content'}
            type={'textarea'}
            value={item.Content}
          />
        </Col>
      </Row>
    </>
  );
};

export default RegattaScheduleFieldsView;
